import React from "react";
import Collapse, { CollapsePanel } from "../ui/Collapse";
import "./GMBScoring.css";
import LockOverview from "./LockOverview";
import useLang from "../../i18n/useLang";
import content from "./content";

const ValidCriteria = ({ valid, hasFullAccess }) => {
  const t = content[useLang()].valid;

  if (!valid || valid.length === 0) {
    return (
      <div className="audit-section" style={{ marginTop: 24 }}>
        <div className="audit-section__header">
          <span className="audit-section__badge audit-section__badge--green">0</span>
          <h4 className="audit-section__title">{t.title}</h4>
        </div>
        <p className="audit-section__empty">{t.empty}</p>
      </div>
    );
  }

  const visibleValid = hasFullAccess ? valid : valid.slice(0, 3);

  return (
    <div className="audit-section" style={{ marginTop: 24 }}>
      <div className="audit-section__header">
        <span className="audit-section__badge audit-section__badge--green">{valid.length}</span>
        <h4 className="audit-section__title">{t.title}</h4>
      </div>
      <Collapse>
        {visibleValid.map((val, i) => (
          <CollapsePanel
            header={val.header}
            extra={<span className="audit-section__status audit-section__status--valid">{t.status}</span>}
            key={val.header}
            defaultOpen={i === 0}
          >
            <p className="audit-section__content">{val.content}</p>
          </CollapsePanel>
        ))}
      </Collapse>
      {!hasFullAccess && valid.length > 3 && (
        <LockOverview isIssue={false} />
      )}
    </div>
  );
};

export default ValidCriteria;
